import Vue from 'vue'

import RbTextModule from '@/elements/editorial/text-module/rb-text-module.vue'
Vue.component('rb-text-module', RbTextModule)

import RbFullWidthBanner from '@/elements/editorial/cms-layout-variants-wrappers/rb-full-width-banner/rb-full-width-banner.vue'
Vue.component('rb-full-width-banner', RbFullWidthBanner)

import RbTopPageBanner from '@/elements/editorial/cms-layout-variants-wrappers/rb-top-page-banner/rb-top-page-banner.vue'
Vue.component('rb-top-page-banner', RbTopPageBanner)

import RbTopPageBannerXs from '@/elements/editorial/cms-layout-variants-wrappers/rb-top-page-banner-xs/rb-top-page-banner-xs.vue'
Vue.component('rb-top-page-banner-xs', RbTopPageBannerXs)

import RbLandscapeBanner from '@/elements/editorial/cms-layout-variants-wrappers/rb-landscape-banner/rb-landscape-banner.vue'
Vue.component('rb-landscape-banner', RbLandscapeBanner)

import RbBoardWithFieldsOn from '@/elements/editorial/cms-layout-variants-wrappers/rb-board-with-fields-on/rb-board-with-fields-on.vue'
Vue.component('rb-board-with-fields-on', RbBoardWithFieldsOn)

import RbBoardWithFieldsOnStackedMobile from '@/elements/editorial/cms-layout-variants-wrappers/rb-board-with-fields-on-stacked-mobile/rb-board-with-fields-on-stacked-mobile.vue'
Vue.component('rb-board-with-fields-on-stacked-mobile', RbBoardWithFieldsOnStackedMobile)

import RbBoardWithFieldsBelow from '@/elements/editorial/cms-layout-variants-wrappers/rb-board-with-fields-below/rb-board-with-fields-below.vue'
Vue.component('rb-board-with-fields-below', RbBoardWithFieldsBelow)

import RbBoardWithFieldsBelowStackedMobile from '@/elements/editorial/cms-layout-variants-wrappers/rb-board-with-fields-below-stacked-mobile/rb-board-with-fields-below-stacked-mobile.vue'
Vue.component('rb-board-with-fields-below-stacked-mobile', RbBoardWithFieldsBelowStackedMobile)

import RbBoardWithFieldsOnNoIconsMobile from '@/elements/editorial/cms-layout-variants-wrappers/rb-board-with-fields-on-mobile/rb-board-with-fileds-on-no-icons-mobile.vue'
Vue.component('rb-board-with-fields-on-no-icons-mobile', RbBoardWithFieldsOnNoIconsMobile)

import RbBannerTextBelow from '@/elements/editorial/cms-layout-variants-wrappers/rb-banner-text-below/rb-banner-text-below.vue'
Vue.component('rb-banner-text-below', RbBannerTextBelow)

import RbComboBoards from '@/elements/editorial/cms-layout-variants-wrappers/rb-combo-boards/rb-combo-boards.vue'
Vue.component('rb-combo-boards', RbComboBoards)

import RbComboBoardsDouble from '@/elements/editorial/cms-layout-variants-wrappers/rb-combo-boards-double/rb-combo-boards-double.vue'
Vue.component('rb-combo-boards-double', RbComboBoardsDouble)

import RbInfographicBox from '@/elements/editorial/cms-layout-variants-wrappers/rb-infographic-box/rb-infographic-box.vue'
Vue.component('rb-infographic-box', RbInfographicBox)

import RbTilesWrapper from '@/elements/editorial/rb-tiles-wrapper/rb-tiles-wrapper.vue'
Vue.component('rb-tiles-wrapper', RbTilesWrapper)

import RbTilesWrapperDouble from '@/elements/editorial/rb-tiles-wrapper/rb-tiles-wrapper-double.vue'
Vue.component('rb-tiles-wrapper-double', RbTilesWrapperDouble)

import RbBannerTextOn from '@/elements/editorial/cms-layout-variants-wrappers/rb-banner-text-on/rb-banner-text-on.vue'
Vue.component('rb-banner-text-on', RbBannerTextOn)

import RbBannerTile from '@/elements/editorial/cms-layout-variants-wrappers/rb-banner-tile/rb-banner-tile.vue'
Vue.component('rb-banner-tile', RbBannerTile)

import RbNewsletterBanner from '@/elements/editorial/cms-layout-variants-wrappers/rb-newsletter-banner/rb-newsletter-banner.vue'
Vue.component('rb-newsletter-banner', RbNewsletterBanner)

import RbPlainSlider from '@/elements/editorial/cms-layout-variants-wrappers/rb-plain-slider/rb-plain-slider.vue'
Vue.component('rb-plain-slider', RbPlainSlider)

import RbSmartBox from '@/elements/editorial/cms-layout-variants-wrappers/rb-smart-box/rb-smart-box.vue'
Vue.component('rb-smart-box', RbSmartBox)

import RbMiniSlider from '@/elements/editorial/cms-layout-variants-wrappers/rb-mini-slider/rb-mini-slider.vue'
Vue.component('rb-mini-slider', RbMiniSlider)

import RbBlurredSlider from '@/elements/editorial/cms-layout-variants-wrappers/rb-blurred-slider/rb-blurred-slider.vue'
Vue.component('rb-blurred-slider', RbBlurredSlider)

import RbSliderItem from '@/elements/editorial/cms-layout-variants-wrappers/rb-slider-item/rb-slider-item.vue'
Vue.component('rb-slider-item', RbSliderItem)

import RbComboMiniSlider from '@/elements/editorial/cms-layout-variants-wrappers/rb-combo-mini-slider/rb-combo-mini-slider.vue'
Vue.component('rb-combo-mini-slider', RbComboMiniSlider)

import RbComboOfBoardsWithAllFieldsBelow from '@/elements/editorial/cms-layout-variants-wrappers/rb-combo-of-boards-with-all-fields-below/rb-combo-of-boards-with-all-fields-below.lazy.vue'
Vue.component('rb-combo-of-boards-with-all-fields-below', RbComboOfBoardsWithAllFieldsBelow)

import RbVerticalWrapper from '@/elements/editorial/cms-layout-variants-wrappers/rb-vertical-banner/rb-vertical-wrapper.vue'
Vue.component('rb-vertical-wrapper', RbVerticalWrapper)

import RbGenderWrapper from '@/elements/editorial/cms-layout-variants-wrappers/rb-gender-module/rb-gender-wrapper.vue'
Vue.component('rb-gender-wrapper', RbGenderWrapper)

import RbGenderModule from '@/elements/editorial/cms-layout-variants-wrappers/rb-gender-module/rb-gender-module.vue'
Vue.component('rb-gender-module', RbGenderModule)

import RbVerticalBanner from '@/elements/editorial/cms-layout-variants-wrappers/rb-vertical-banner/rb-vertical-banner.vue'
Vue.component('rb-vertical-banner', RbVerticalBanner)

import RbHolidayWrapper from '@/elements/editorial/cms-layout-variants-wrappers/rb-holiday-banner/rb-holiday-wrapper.vue'
Vue.component('rb-holiday-wrapper', RbHolidayWrapper)

import RbHolidayBanner from '@/elements/editorial/cms-layout-variants-wrappers/rb-holiday-banner/rb-holiday-banner.vue'
Vue.component('rb-holiday-banner', RbHolidayBanner)

import Rb3dCarousel from '@/elements/editorial/cms-layout-variants-wrappers/rb-3d-carousel/rb-3d-carousel.vue'
Vue.component('rb-3d-carousel', Rb3dCarousel)

import Rb3dBanner from '@/elements/editorial/cms-layout-variants-wrappers/rb-3d-carousel/rb-3d-banner.vue'
Vue.component('rb-3d-banner', Rb3dBanner)

import Rb3dProduct from '@/elements/editorial/cms-layout-variants-wrappers/rb-3d-carousel/rb-3d-product.vue'
Vue.component('rb-3d-product', Rb3dProduct)

import Rb3dToggle from '@/elements/editorial/cms-layout-variants-wrappers/rb-3d-carousel/rb-3d-toggle.vue'
Vue.component('rb-3d-toggle', Rb3dToggle)

import RbBoardWithFieldsAside from '@/elements/editorial/cms-layout-variants-wrappers/rb-board-with-fields-aside/rb-board-with-fields-aside.vue'
Vue.component('rb-board-with-fields-aside', RbBoardWithFieldsAside)

import RbBannerFieldsAside from '@/elements/editorial/cms-layout-variants-wrappers/rb-banner-fields-aside/rb-banner-fields-aside.vue'
Vue.component('rb-banner-fields-aside', RbBannerFieldsAside)

import RbSmartContainer from '@/elements/smart-container/smart-container.vue'
Vue.component('rb-smart-container', RbSmartContainer)

import RbFaqBanner from '@/elements/editorial/cms-layout-variants-wrappers/rb-faq-banner/rb-faq-banner.vue'
Vue.component('rb-faq-banner', RbFaqBanner)

import RbPlpHeroBanner from '@/elements/editorial/cms-layout-variants-wrappers/rb-plp-hero-banner/rb-plp-hero-banner.vue'
Vue.component('rb-plp-hero-banner', RbPlpHeroBanner)
